module.exports = __webpack_public_path__ + "img/hr-V-R-2-unload-standup-shadow.c08372aa.png";